// OptionDetailsListItemDelete.js

export default function OptionDetailsListItemDelete(P_OptionDetailsListItem){
    P_OptionDetailsListItem.Valid = false;
    P_OptionDetailsListItem.Updated.Valid = true;
}